<template>
  <b-row>
    <b-col>
      <b-form-group
        v-if="shipmentAddresses && shipmentAddresses.length"
        id="shipmentaddressgroup"
        :label="$t('selectAnExistingShipmentAddress')"
        label-for="shipmentaddress"
      >
        <b-form-select
          id="shipmentaddress"
          v-model="selectedAddress"
          :value="selectedAddress"
          :options="shipmentAddresses"
        ></b-form-select>
      </b-form-group>
    </b-col>
  </b-row>
</template>

<script>
import { BRow, BCol, BFormGroup, BFormSelect } from "bootstrap-vue"
import { getCustomerShipmentAddresses } from "@/services/customer"

export default {
  components: {
    BRow,
    BCol,
    BFormGroup,
    BFormSelect,
  },
  props: {
    shipmentAddressId: {
      type: Number,
      required: false,
      default: null,
    },
  },
  data() {
    return {
      shipmentAddresses: [],
    }
  },
  computed: {
    selectedAddress: {
      get() {
        if (this.shipmentAddressId) {
          return this.getAddressByAddressId(this.shipmentAddressId).value
        }
        return null
      },
      set(val) {
        console.log({ val })

        this.$emit("input", val)
      },
    },
  },
  created: async function () {
    const result = await getCustomerShipmentAddresses({
      customerID: this.$store.getters.customerID,
    })
    this.shipmentAddresses = this.variantValuesToSelectOptions(result)

    this.setDefaultShipmentAddress()
  },
  methods: {
    setDefaultShipmentAddress() {
      const defaultAddress = this.shipmentAddresses.find(
        (address) => address.value?.isDefault
      )
      this.$emit("input", defaultAddress.value)
    },
    getAddressByAddressId(addressID) {
      return this.shipmentAddresses.find(
        (address) => address.value?.addressID === addressID
      )
    },
    variantValuesToSelectOptions(addresses) {
      const selectAddresses = []
      selectAddresses.push({
        text: this.$t("newAddress"),
        value: null,
        selected: true,
      })
      for (const address of addresses) {
        selectAddresses.push({
          text: this.$t("key", {
            street: address.street,
            expr: address.houseNumber ?? "",
          }),
          value: address,
        })
      }
      return selectAddresses
    },
  },
}
</script>

<style></style>
